import { useState } from "react";
import useTranslation from "next-translate/useTranslation";
import truncate from "utils/truncate.utils";

type Description = string;
type HasLimit = boolean;
type IsReadMore = boolean;
type HelperText = string;
type OnClick = () => void;

function useReadMore(
  text: string,
  limit: number = 170
): [Description, HasLimit, HelperText, OnClick, IsReadMore] {
  const { t } = useTranslation("common");
  const [isReadMore, setIsReadMore] = useState(false);

  const hasLimit = text.length > limit;
  const truncatedText = truncate(text, {
    length: limit,
    separator: " ",
    ellipsis: "",
  });
  const description = isReadMore ? text : truncatedText;

  const helperText = isReadMore ? t("global.showless") : t("global.showmore");

  const onClickButton = () => setIsReadMore((prevState) => !prevState);

  return [description, hasLimit, helperText, onClickButton, isReadMore];
}

export default useReadMore;
